import * as yup from 'yup';

export const BranchTemplateSchema = yup.object().shape({
  name: yup.string().required('Ingresa el nombre de la plantilla'),
  puestos: yup
    .array()
    .min(1, 'Selecciona al menos un puesto')
    .required('Selecciona al menos un puesto'),
});
